import React, { useState } from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { SiteStandardUpdate } from "./siteStandardUpdate";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";

const siteStandardColumns = [
  {
    label: "Title",
    keyField: "siteStandardKey",
    dataField: "name",
    dataType: "string",
  },
  {
    label: "Start Date",
    keyField: "siteStandardKey",
    dataField: "startDate",
    dataType: "date",
  },
  {
    label: "End Date",
    keyField: "siteStandardKey",
    dataField: "endDate",
    dataType: "date",
  },
  {
    label: "Status",
    keyField: "siteStandardKey",
    dataField: "active",
    dataType: "boolean",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "",
    keyField: "siteStandardKey",
    dataField: "siteStandardKey",
    dataType: "number",
    minWidth: 20,
    maxWidth: 20,
  },
];

const siteStandardSearchColumns = ["name", "startDate", "endDate"];

export const SiteStandardConfig = () => {
  const facilityId = useSelector((state) => state.SelectedValues.facilityId);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [siteStandardEdit, setSiteStandardEdit] = useState(null);
  const [siteStandardAttributes, setSiteStandardAttributes] = useState({
    siteStandardKey: 0,
    facilityKey: facilityId,
    name: "",
    startDate: "",
    endDate: "",
    shift1Start: "",
    shift2Start: "",
    shift3Start: "",
    rtacustomer: 0,
    dtccustomer: 0,
    rtccustomer: 0,
    rtacompany: 0,
    dtccompany: 0,
    rtccompany: 0,
    tpph: 0,
    lunchTime: "",
    breakTime: "",
    active: true,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchSiteStandardDetails } = useHttpRequests();

  const siteStandardEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getSiteStandardDetails = (siteStandardObj) => {
      if (
        !siteStandardObj ||
        !siteStandardObj.isSuccess ||
        siteStandardObj.errorResponse
      ) {
        console.log("siteStandard fetch response returns error");
        return;
      }

      setSiteStandardAttributes({
        siteStandardKey: siteStandardObj["siteStandard"]["siteStandardKey"],
        facilityKey: facilityId,
        name: siteStandardObj["siteStandard"]["name"],
        startDate: siteStandardObj["siteStandard"]["startDate"],
        endDate: siteStandardObj["siteStandard"]["endDate"],
        shift1Start: new Date().toISOString().split('T')[0] + "T" + siteStandardObj["siteStandard"]["shift1Start"],
        shift2Start: new Date().toISOString().split('T')[0] + "T" + siteStandardObj["siteStandard"]["shift2Start"],
        shift3Start: new Date().toISOString().split('T')[0] + "T" + siteStandardObj["siteStandard"]["shift3Start"],
        rtacustomer: siteStandardObj["siteStandard"]["rtacustomer"],
        dtccustomer: siteStandardObj["siteStandard"]["dtccustomer"],
        rtccustomer: siteStandardObj["siteStandard"]["rtccustomer"],
        rtacompany: siteStandardObj["siteStandard"]["rtacompany"],
        dtccompany: siteStandardObj["siteStandard"]["dtccompany"],
        rtccompany: siteStandardObj["siteStandard"]["rtccompany"],
        tpph: siteStandardObj["siteStandard"]["tpph"],
        lunchTime: siteStandardObj["siteStandard"]["lunchTime"],
        breakTime: siteStandardObj["siteStandard"]["breakTime"],
        active: siteStandardObj["siteStandard"]["active"],
      });

      setSiteStandardEdit(true);
      setUpdateOpen(true);
    };

    fetchSiteStandardDetails(
      { url: "SiteStandards/" + key, method: "GET", header: true },
      getSiteStandardDetails
    );
  };

  const changeSiteStandardStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "Site standard status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "siteStandards/",
      keyField: "siteStandardKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    if (facilityId > 0) {
      return "siteStandards?facilityKey=" + facilityId;
    }
    return null;
  };

  const siteStandardDetailProps = {
    setUpdateOpen,
    siteStandardEdit,
    setSiteStandardEdit,
    siteStandardAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={siteStandardColumns}
              url={getUrl}
              sourceObj="siteStandards"
              editHandler={siteStandardEditHandler}
              updateOpen={updateOpen}
              searchOnColumns={siteStandardSearchColumns}
              changeStatus={changeSiteStandardStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setSiteStandardAttributes({
                  siteStandardKey: 0,
                  facilityKey: facilityId,
                  name: "",
                  startDate: "",
                  endDate: "",
                  shift1Start: "",
                  shift2Start: "",
                  shift3Start: "",
                  rtacustomer: 0,
                  dtccustomer: 0,
                  rtccustomer: 0,
                  rtacompany: 0,
                  dtccompany: 0,
                  rtccompany: 0,
                  tpph: 0,
                  lunchTime: "",
                  breakTime: "",
                  active: true,
                });
                setSiteStandardEdit(false);
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <SiteStandardUpdate {...siteStandardDetailProps} />
        </div>
      )}
    </div>
  );
};
